import React from "react";
import { StyledColorPicker } from "./styled";

interface Props {
  value: string;
  onChange: (color: string) => void;
  label: string;
  id: string;
  style?: React.CSSProperties;
}

const ColorPicker: React.FC<Props> = ({
  value,
  onChange,
  label,
  id,
  style,
}) => {
  return (
    <StyledColorPicker style={style} color={value}>
      <label htmlFor={id} className="color-cont"></label>
      <input
        type="color"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        id={id}
      />
      <label>{label}</label>
    </StyledColorPicker>
  );
};

export default ColorPicker;
